// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null
}

const rokuChannel = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        params: action.params
      }
    case 'GET_ROW':
      return {
        ...state,
        data: action.data,
        params: action.params
      }
    default:
      return { ...state }
  }
}
export default rokuChannel
